import { useState } from "react";
import { SettlementHeader } from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/customButton/CustomButton";
import CustomTable from "../../../components/customTable/CustomTable";

import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { DateRange } from "../../../resources/assetsManager";

const Data = [
  {
    year: "Jan",
    fees: "₹2,000.00",
  },
  {
    year: "Feb",
    fees: "₹5,000.00",
  },
  {
    year: "Mar",
    fees: "₹6,000.00",
  },
];

const Settlement = () => {
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  return (
    <div>
      <TopHeaderComponent
        showDownload={false}
        headerName="Settlement"
        showFilter={false}
      />

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          width: "100%",
          marginTop: 15,
        }}
      >
        <div
          style={{
            color: "black",
            padding: "30px 40px",
            borderBottom: "1px solid black",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ color: "black" }}>
            <p
              style={{ fontSize: "18px", fontWeight: "500", margin: 0 }}
              className="roboto"
            >
              MONTHLY INVOICE
            </p>
            <p
              style={{ fontSize: "14px", margin: 0, marginTop: 5 }}
              className="roboto"
            >
              Your monthly for fees and taxes charged by Neokred on transaction.
            </p>
          </div>

          <CustomButton
            styles={{ border: "0px solid black", margin: 0, marginTop: 10 }}
            icon={DateRange}
            title={"Select Month"}
          />
        </div>

        <div>
          <CustomTable
            headers={SettlementHeader}
            data={Data}
            settlement
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default Settlement;
